<template>
    <MainModal :show-modal="showModal" size="sm" :footer="false" :close-btn="false">
        <template #body>
            <div class="grid gap-2">
                <div class="upgrade--image">
                    <h2 class="text-gray-500">
                        COMING SOON
                    </h2>
                </div>

                <div class="upgrade--text">   
                    <div>
                        <div class="flex align-items-center gap-2 mb--5">
                            <h2 class="upgrade--title text--base mb--0">
                                Invoice tracking
                            </h2>
                            <div v-if="accountPlan === 'free'">
                                <span class="status__map text--medium tag bold badge rounded-pill text--xxs tag--pink text--upper ml--10">
                                    <span 
                                        class="status__circle tag--pink__text text--xxs" 
                                    />
                                    Paid plans only
                                </span>
                            </div>
                        </div>
                        <p class="upgrade--subtitle error">
                            Follow the progress of your invoices in real-time; from creation to final payment.
                        </p>

                        <p class="upgrade--subtitle error">
                            (For failed invoices, click the <strong>Resend</strong> button to resend invoice).
                        </p>
                    </div>
                </div>

                <div class="w-100 flex justify-content-end align-items-center">
                    <BaseButton 
                        class="mr--5" 
                        label="Close" 
                        @submit="$emit('close')"
                    />
                </div>
            </div>
        </template>
    </MainModal>
</template>

<script>
import BaseButton from "../buttons/BaseButton.vue";
import MainModal from "./MainModal.vue";
import { occupationList, zinerUseCases } from "@/utils/dummy";
import countryList from "@/assets/js/countrycodes.json";
import FormLabel from "../forms/FormLabel.vue";
import IconSvg from "../icons/Icon-Svg.vue";
import SvgAssets from "../icons/SvgAssets.vue";

export default {
    name: "InvoiceProgressModal",

    components: {
        MainModal, 
        BaseButton, 
    },

    props: {
        showModal: {
            type: Boolean,
            default: false,
        },

        steps: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            occupationList,
            countries: countryList,
            zinerUseCases,
            step: 1,
            // steps: [
            //     { id: "pending", title: "Processing", description: "System is processing your invoice" },
            //     { id: "issued", title: "Issued", description: "Your invoice has been sent to client" },
            //     { id: "partial_payment", title: "PIP", description: "Payment in Progress" },
            //     { id: "completed", title: "Completed", description: "Invoice paid!" },
            // ],
        };
    },

    computed: {
        enableBtn() {
            if (this.step === 1) return true;

            return Object.values(this.form).some((value) => {                
                if (Array.isArray(value)) {                    
                    return value.length;
                }
                return value;
            });
        },

        profile() {
            return this.$store.getters["auth/profile"];
        },

        stepsWidth() {
            return `${((this.step - 1) / (this.steps.length - 1)) * 100}%`;
        },

        updatedSteps() {
            return this.steps.map((item) => {
                if (item.id < this.step) {
                    return { ...item, status: "completed" };
                } else if (item.id === this.step) {
                    return { ...item, status: "current" };
                } else {
                    return { ...item, status: "upcoming" };
                }
            });
        },

        accountPlan() {
            return this.$store.getters["subscription/subscriptionInfo"]?.plan || "free";
        },

        // constructedSteps() {
        //     const steps = [];
        //     const lastStep = this.steps[this.steps.length - 1];

        //     switch(lastStep.event) {
        //         case "paid":
        //             return [

        //             ]
        //     }
        // }
    },

    methods: {
        getStepStatus(stepId) {
            if (stepId < this.step) return "completed";
            if (stepId === this.step) return "pe";
            return "upcoming";
        },
    },
};
</script>

<style lang="scss" scoped>
    .onboarding {
        &__img__wrap {
            width: 100%;
            display: flex;
            justify-content: center;
            margin-bottom: 30px;
        }

        &__wrap {
            min-height: 550px;
            min-height: 350px;
            display: flex;
            flex-direction: column;
        }

        &__content {
            // padding: 0px 0px 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: calc(100% - 50px);
            flex: 2;
        }

        &__header {
            margin: auto;
            text-align: center;
            max-width: 75%;
            margin-bottom: 2.5rem;
            
            &__title {
                font-weight: 500;
                font-size: 1.25rem;
                color: #171717;
            }

            &.intro {
                margin: 2rem auto;
                max-width: 54.74%;
            }
        }

        &__body {
            &__intro {
                padding: 3rem 0;
                margin: auto;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                h2 {
                    font-size: 2rem;
                    font-weight: 600;
                    color: #09090B;
                    margin-bottom: 0.5rem;
                }

                p {
                    color: var(--grey-600);
                    font-size: 0.875rem;
                    text-align: center;
                    max-width: 50%;
                }

                &__btns {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    margin-top: 4rem;
                    max-width: 50%;
                    width: fit-content;
                }   
            }
        }

        &__usecase {
            display: flex;
            flex-wrap: wrap;
            gap: 10px 5px;
            margin-top: 10px;

            &__item {
                display: flex;
                border: 1px solid #cbd5e1;
                padding: 3px 10px;
                background: #fff;
                font-size: 0.875rem;
                border-radius: 6px;     

                &.active {
                    border: 1px solid #289CA9;
                }

                .form-check-label {
                    min-width: 80%;
                }
            }
        }
        &__progress {
            &__item {
                width: 20px;
            }
        }
    }
</style>